import http from '../../utils/httpService';
import { TENANT_STATISTICS_ROUTE } from './constants';

/**
 *
 * @param data
 * @returns {*}
 */
const getTenantSettings = ( data ) => {
    const { data: { from, to } } = data;
    const route = `${ TENANT_STATISTICS_ROUTE }?from=${ from }&to=${ to }`;
    return http.request( route, 'GET', null, false );
};

export { getTenantSettings };